import React from 'react';
import { Control, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { Stack } from '@mui/material';
import { DiscountTypes } from 'api';
import { FormCard, FormInput } from 'components';
import DISCOUNTS from 'constants/discounts';
import { dataInitialSelectsOptions } from '../../../fields';
import CartTierInputs from './CartTierInputs';
import CollectionsInput from '../CollectionsInput';

interface Props {
  control: Control<DiscountTypes.ItemCreateParams> | undefined;
  watch: UseFormWatch<DiscountTypes.ItemCreateParams>;
  setValue: UseFormSetValue<DiscountTypes.ItemCreateParams>;
  initialSelectsOptions:
    | ReturnType<typeof dataInitialSelectsOptions>
    | undefined;
}

const QuantityDiscount: React.FC<Props> = (props: Props): JSX.Element => {
  const { control, watch, setValue, initialSelectsOptions } = props;

  return (
    <FormCard title="Settings">
      <Stack spacing={2}>
        <CollectionsInput
          name="metafields_attributes.0.value.selectCollection"
          control={control}
          watch={watch}
          initialValue={initialSelectsOptions?.metafieldsCollections}
          onChange={(value) => {
            const ids = value.map((v) => v.id);
            setValue(
              'metafields_attributes.0.value.selectedCollectionIds',
              ids,
            );
          }}
        />
        <CartTierInputs
          control={control}
          name="metafields_attributes.0.value.cart_value_tiers"
          setValue={setValue}
          watch={watch}
        />
        <FormInput
          control={control}
          name="metafields_attributes.0.value.mix_and_match"
          inputType="switch"
          label="Mix and match"
          onChange={(e) => {
            const target = e.target as HTMLInputElement;
            const { checked } = target;
            setValue('metafields_attributes.0.value.mix_and_match', checked);
            setValue('metafields_attributes.0.value.mixmatch', checked);
          }}
        />
        <FormInput
          control={control}
          name="metafields_attributes.0.value.basis"
          inputType="radio"
          label="Discount calculation"
          options={DISCOUNTS.BASIS_OPTIONS}
          helperText="Discounted price will be calculated based on the selected option"
        />
      </Stack>
    </FormCard>
  );
};

export default QuantityDiscount;
